import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'
import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import StatBox from '../Components/StatBox'
import StakingWeekChart from './Components/StakingWeekChart'
import StakeChart from './Components/StakeChart'

import useViewModel from './ViewModel'

const DashboardOperationView: React.FC = () => {
  const { statBoxes, projectPileStats, projectPilingProgress } = useViewModel()

  return (
    <ViewPageTitle>
      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <PageBreadCrumb />
        </div>

        {/* begin:: Stat */}
        <div className='col-12'>
          <div className='row'>
            {statBoxes.map(item => (
              <div className='col-12 col-xl-3' key={`stat-box-${item.title}`}>
                <StatBox {...item} />
              </div>
            ))}
          </div>
        </div>
        {/* end:: Stat */}

        <div className='row mb-5 gy-5'>
          {/* begin:: Stake Overview Chart */}
          <div className='col-xl-6 col-12'>
            <div className='card h-100'>
              <div className='card-header'>
                {/* Title */}
                <div className='card-title fw-bolder'>จำนวนเสาของทุกหน่วยงาน</div>
                {/* <div className='card-toolbar'>
                  <div className='d-flex flex-row align-items-center'>
                    <div
                      className='d-flex align-items-center justify-content-center'
                      style={{ columnGap: '12px' }}>
                      <div className='form-check form-check-custom'>
                        <input className='form-check-input' type='checkbox' />
                        <label className='ms-2'>Chart</label>
                      </div>

                      <div className='form-check form-check-custom'>
                        <input className='form-check-input' type='checkbox' />
                        <label className='ms-2'>Show Value</label>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className='card-body'>
                {/* Chart */}
                <div className='row align-items-center justify-content-center h-100'>
                  <div className='col-12 col-xl-4 text-center d-flex flex-column align-items-center'>
                    <StakeChart
                      color='#00B074'
                      secondaryColor='#91d7c0'
                      value={projectPileStats?.totalPileHammeredSuccess ?? 0}
                    />
                    <span>จำนวนเสาที่ตอกสำเร็จ (ต้น)</span>
                  </div>

                  <div className='col-12 col-xl-4 text-center d-flex flex-column align-items-center'>
                    <StakeChart
                      color='#FF5B5B'
                      secondaryColor='#fb9c9c'
                      value={projectPileStats?.totalPileHammeredWasted ?? 0}
                    />
                    <span>จำนวนเสาที่ตอกเสีย (ต้น)</span>
                  </div>

                  <div className='col-12 col-xl-4 text-center d-flex flex-column align-items-center'>
                    <StakeChart
                      color='#2D9CDB'
                      secondaryColor='#a3cde5'
                      value={projectPileStats?.totalStockQuantity ?? 0}
                    />
                    <span>จำนวนเสาที่อยู่ในสต็อก (ท่อน)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end:: Stake Overview Chart */}

          {/* begin:: Staking in This Week Chart */}
          <div className='col-xl-6 col-12'>
            <div className='card'>
              <div className='card-header'>
                <div className='card-title fw-bolder'>การตอกเสาเข็มสัปดาห์นี้</div>
              </div>

              <div className='card-body'>
                <StakingWeekChart data={projectPilingProgress} />
              </div>
            </div>
          </div>
          {/* end:: Staking in This Week Chart */}
        </div>

        <div className='row mb-5 gy-5'>
          {/* begin:: Comparison Chart */}
          {/* <div className='col-xl-4 col-12'>
            <div className='card h-100'>
              <div className='card-header'>
                <div className='card-title fw-bolder'>เปรียบเทียบแต่ละหน่วยงาน</div>
              </div>

              <div className='card-body justify-content-end align-items-end d-flex'>
                <ComparisonBarChart />
              </div>
            </div>
          </div> */}
          {/* end:: Comparison Chart */}

          {/* begin:: Progression Chart */}
          {/* <div className='col-xl-8 col-12'>
            <div className='card'>
              <div className='card-header'>
                <div className='card-title fw-bolder'>Progression</div>

                <div className='card-toolbar'>
                  <Select
                    placeholder='Year'
                    defaultValue={{ label: '2023', value: '2023' }}
                    options={[
                      {
                        label: '2023',
                        value: '2023',
                      },
                      {
                        label: '2022',
                        value: '2022',
                      },
                      {
                        label: '2021',
                        value: '2021',
                      },
                    ]}
                  />
                </div>
              </div>

              <div className='card-body'>
                {/* Date Range Selector
                <div className='button-group mb-3'>
                  <button
                    type='button'
                    className='btn btn-sm white-button left border border-2 w-100'>
                    1D
                  </button>

                  <button
                    type='button'
                    className='btn btn-sm white-button middle border border-2 w-100'>
                    1M
                  </button>

                  <button
                    type='button'
                    className='btn btn-sm white-button middle border border-2 w-100'>
                    3M
                  </button>

                  <button
                    type='button'
                    className='btn btn-sm white-button middle border border-2 w-100'>
                    1Y
                  </button>

                  <button
                    type='button'
                    className='btn btn-sm white-button right border border-2 w-100'>
                    YTD
                  </button>
                </div>

                {/* Chart
                <ProgressionChart color='#F26B4D' lightColor='#f5bdb1' />
              </div>
            </div>
          </div> */}
          {/* end:: Progression Chart */}
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '#',
            title: 'Dashboard',
            icon: '/media/icons/duotune/general/gen005.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'ปฏิบัติการ',
          },
        ]}>
        ปฏิบัติการ
      </PageTitle>

      {children}
    </>
  )
}

export default DashboardOperationView
